import { Settings as SettingsIcon, Smartphone, MessageSquare, Bell, CreditCard, User } from "lucide-react";
import { SEO } from "@/components/seo/SEO";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GestureSettings } from "@/components/settings/GestureSettings";
import { MyFeedbackHistory } from "@/components/settings/MyFeedbackHistory";
import { FeedbackNotifications, FeedbackNotificationBadge } from "@/components/notifications/FeedbackNotifications";
import { AllSubscriptionsManager } from "@/components/subscription/AllSubscriptionsManager";
import { AccountSettings } from "@/components/settings/AccountSettings";

export default function Settings() {
  return (
    <>
      <SEO
        title="Settings - QuickMedicalReview"
        description="Customize your learning experience with mobile gestures, study preferences, and account settings."
      />
      
      <div className="max-w-4xl mx-auto space-y-6 pb-20 md:pb-6">
        {/* Page Header */}
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-gradient-medical flex items-center justify-center">
            <SettingsIcon className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold">Settings</h1>
            <p className="text-muted-foreground">Customize your learning experience</p>
          </div>
        </div>

        {/* Settings Tabs */}
        <Tabs defaultValue="gestures" className="w-full">
          <TabsList className="grid w-full grid-cols-5 md:grid-cols-7 h-auto">
            <TabsTrigger value="gestures" className="gap-2">
              <Smartphone className="h-4 w-4" />
              Mobile & Gestures
            </TabsTrigger>
            <TabsTrigger value="feedback" className="gap-2">
              <MessageSquare className="h-4 w-4" />
              My Feedback
            </TabsTrigger>
            <TabsTrigger value="responses" className="gap-2">
              <Bell className="h-4 w-4" />
              Responses
              <FeedbackNotificationBadge />
            </TabsTrigger>
            <TabsTrigger value="subscription" className="gap-2">
              <CreditCard className="h-4 w-4" />
              Subscription
            </TabsTrigger>
            <TabsTrigger value="account" className="gap-2">
              <User className="h-4 w-4" />
              Account
            </TabsTrigger>
            <TabsTrigger value="study" disabled className="gap-2">
              Study Preferences
            </TabsTrigger>
            <TabsTrigger value="notifications" disabled className="gap-2">
              Notifications
            </TabsTrigger>
          </TabsList>

          <TabsContent value="gestures" className="space-y-4 mt-6">
            <GestureSettings />
          </TabsContent>

          <TabsContent value="feedback" className="space-y-4 mt-6">
            <MyFeedbackHistory />
          </TabsContent>

          <TabsContent value="responses" className="space-y-4 mt-6">
            <FeedbackNotifications />
          </TabsContent>

          <TabsContent value="subscription" className="space-y-4 mt-6">
            <AllSubscriptionsManager />
          </TabsContent>

          <TabsContent value="account" className="mt-6">
            <AccountSettings />
          </TabsContent>

          <TabsContent value="study" className="mt-6">
            <Card>
              <CardHeader>
                <CardTitle>Study Preferences</CardTitle>
                <CardDescription>Coming soon: Default difficulty, auto-advance, timer preferences</CardDescription>
              </CardHeader>
              <CardContent className="text-muted-foreground">
                This feature is under development
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="notifications" className="mt-6">
            <Card>
              <CardHeader>
                <CardTitle>Notification Settings</CardTitle>
                <CardDescription>Coming soon: Email notifications, push notifications, study reminders</CardDescription>
              </CardHeader>
              <CardContent className="text-muted-foreground">
                This feature is under development
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
}
